const firstDefined = (...values) => values.find((value) => value !== undefined && value !== null);

const asArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value && Array.isArray(value.data)) return value.data;
  return [];
};

export const normalisePaginatedCollection = (payload, keys = [], defaultPageSize = 10) => {
  const envelope = payload || {};
  const source = envelope.data && !Array.isArray(envelope.data) ? envelope.data : envelope;
  const collection =
    keys.map((key) => source[key]).find(Boolean) ||
    source.data ||
    (Array.isArray(source) ? source : []);
  const items = asArray(collection);
  const meta =
    collection?.pagination ||
    collection?.meta ||
    source.pagination ||
    source.meta ||
    envelope.pagination ||
    envelope.meta ||
    {};

  return {
    data: items,
    currentPage: firstDefined(collection?.current_page, meta.current_page, source.current_page, 1),
    total: firstDefined(collection?.total, meta.total, source.total, items.length),
    perPage: firstDefined(collection?.per_page, meta.per_page, source.per_page, defaultPageSize),
    from: firstDefined(collection?.from, meta.from, source.from, items.length ? 1 : 0),
    to: firstDefined(collection?.to, meta.to, source.to, items.length),
  };
};

export const paginateCollection = (items, requestedPage = 1, perPage = 10) => {
  const collection = Array.isArray(items) ? items : [];
  const pageSize = Math.max(Number(perPage) || 1, 1);
  const lastPage = Math.max(Math.ceil(collection.length / pageSize), 1);
  const currentPage = Math.min(Math.max(Number(requestedPage) || 1, 1), lastPage);
  const start = (currentPage - 1) * pageSize;
  const data = collection.slice(start, start + pageSize);

  return {
    data,
    currentPage,
    total: collection.length,
    perPage: pageSize,
    from: data.length ? start + 1 : 0,
    to: data.length ? start + data.length : 0,
  };
};
